import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { getMasterCameraNvrList } from "../../redux/actions/MasterActions";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import Preloader from "../../Components/Preloader";
import { getCameraNvrListById, getCameraNvrList,saveCameraNvrData, updateCameraNvrData } from "../../redux/actions/CameraNvrActions";

const ViewVideo = () => {
  const { id } = useParams();
  const navigate = useNavigate();
    const [fieldErrors, setFieldErrors] = useState({});

  const { t } = useTranslation();
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    cameraNvrReducer: {
      loadingCameraNvr,
      errorsCameraNvr,
      cameraNvrLists,
      changedCameraNvrStatus,
    },
    masterReducer: {
      masterCameraNvrLists,
      loadingMaster,
      errorsMaster,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getMasterCameraNvrList(auth?.accessToken));
    }
  }, [auth?.accessToken]);

  useEffect(() => {
    if (id) {
      dispatch(getCameraNvrListById(auth?.accessToken, id));
    }
  }, [auth, id]);


  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (id) {
    const updatedpayload = { id: formData?.id,
   type: "update",
  "nvrName": formData?.nvrName,
  nvrId: formData?.nvrId,
          "nvrUrl": formData?.nvrUrl,
          "nvrUsername": formData?.nvrUsername,
          "location": formData?.location,
          "nvrPort": Number(formData?.nvrPort),
          "nvrPassword": formData?.nvrPassword,
          "status": formData?.newStatus,
        };

      dispatch(updateCameraNvrData(auth?.accessToken, updatedpayload, id));
    }
    else {
const payload = {
  type: "update",
  "nvrName": formData?.nvrName,
  nvrId: formData?.nvrId,
          "nvrUrl": formData?.nvrUrl,
          "nvrUsername": formData?.nvrUsername,
          "location": formData?.location,
          "nvrPort": Number(formData?.nvrPort),
          "nvrPassword": formData?.nvrPassword,
          "status": formData?.newStatus,
        };

      // console.log('formData', formData);
      dispatch(saveCameraNvrData(auth?.accessToken, payload));
    }
  };

  useEffect(() => {
    if (id) {
      if (cameraNvrLists && Object.keys(cameraNvrLists).length > 0) {
        setFormData({
          "nvrName": cameraNvrLists?.nvrName,
          "nvrUrl": cameraNvrLists?.nvrUrl,
          "nvrUsername": cameraNvrLists?.nvrUsername,
          "nvrPassword": cameraNvrLists?.nvrPassword,
          "location": cameraNvrLists?.location,
          "nvrPort": cameraNvrLists?.nvrPort,
          "nvrId": cameraNvrLists?.id,
          "status": cameraNvrLists?.status,

        });
      }
    }

  }, [cameraNvrLists])

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      if (errorsCameraNvr?.status === 401) {
        dispatch(logout());
        toast.error(errorsCameraNvr?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  }, [errorsCameraNvr, dispatch, navigate]);

  useEffect(() => {
    if (errorsCameraNvr && Object.keys(errorsCameraNvr).length > 0) {
      if (errorsCameraNvr?.status === 401) {
        dispatch(logout())
        toast.error(errorsCameraNvr?.data?.message);
        navigate('/login');
        //window.location.reload();
      }
      else if (errorsCameraNvr?.status === 409) {
        swal.fire({
          show: true,
          title: "Oops!",
          text: errorsCameraNvr?.data?.message,
          icon: "error",
          showConfirmButton: false,
          timer: 1500
        });
        dispatch({ type: 'RESET_DELETE_CAMERANVR_STATUS' });
      } else if (errorsCameraNvr?.status === 400) {
        // Handle other status
          if (errorsCameraNvr?.data?.errors && Array.isArray(errorsCameraNvr.data.errors)) {
          const transformedErrors = {};
          errorsCameraNvr.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }
      } else {
        dispatch({ type: 'RESET_DELETE_CAMERANVR_STATUS' });
      }
    }
  }, [errorsCameraNvr, dispatch]);

  useEffect(() => {
    if (errorsCameraNvr && Object.keys(errorsCameraNvr).length > 0) {
      if (errorsCameraNvr?.status === 401) {
        dispatch(logout())
        toast.error(errorsCameraNvr?.data?.message);
        navigate('/login');
      }
    }
  }, [errorsCameraNvr]);
  useEffect(() => {
    if (changedCameraNvrStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedCameraNvrStatus?.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_CAMERANVR_STATUS' });
      navigate(-1);
    }
  }, [changedCameraNvrStatus, dispatch, navigate]);

  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_CAMERANVR_STATUS' });
  }, [dispatch]);

  const inputHandler = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase(); // Remove spaces and convert to uppercase
    setFormData({ ...formData, [name]: processedValue });
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData[0]?.nvrId,
    }));
    if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsCameraNvr?.data?.nvrId ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsCameraNvr?.data?.nvrId ? 'red' : base.borderColor,
      }
    }),
  };

  
    useEffect(() => {
    setFieldErrors({});
},[(navigate)]);
  return (
    <>
     <PageTitle
             breadCrumbItems={[
               { label: t("camera-nvr"), path: "camera-nvr" },
               { label: id ? t("Update camera-nvr") : t("Add camera-nvr"), path: "/Add-camera-nvr", active: true },
             ]}
             title={id ? t("Update camera-nvr") : t("Add camera-nvr")}
           />
           
      <Row>
         <Col lg={3}></Col>
              <Col lg={6}>
          <Card>
            <Card.Body>
              {errorsCameraNvr?.data?.message && (
                <div className="alert alert-danger">
                  {errorsCameraNvr?.data?.message}
                </div>
              )}
              <Row>
              {/* <Col lg={6}>
              <Form.Group className="mb-3">
                <Form.Label>{t("Nvr")}</Form.Label>
                <Select
                  className={fieldErrors?.nvrId ? "border-danger" : ""}
                  options={masterCameraNvrLists}
                  values={masterCameraNvrLists.filter((nvr) => nvr?.nvrId === formData.nvrId)}
                  name="nvrId"
                  labelField={"nvrName"}
                  valueField={"nvrId"}
                  onChange={(selectedData) => selectHandler(selectedData, "nvrId")}
                  styles={customSelectStyles}
                />

                {fieldErrors?.nvrId && (
                  <div className="invalid-feedback d-block">
                    <p className="text-danger">{fieldErrors?.nvrId}</p>
                  </div>
                )}
              </Form.Group>
              </Col> */}
              <Col lg={6}>
               <FormInput
                label={t("NVR URL")}
                type="text"
                errors={fieldErrors}
                value={formData.nvrUrl}
                name="nvrUrl"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
              </Col>
              <Col lg={6}>
              <FormInput
                label={t("NVR Name")}
                type="text"
                errors={fieldErrors}
                value={formData.nvrName}
                name="nvrName"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
              </Col>
              <Col  lg={6}>
              <FormInput
                label={t("NVR USERNAME ")}
                type="text"
                errors={fieldErrors}
                value={formData.nvrUsername}
                name="nvrUsername"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
              </Col>
              <Col  lg={6}>
                 <FormInput
                label={t("NVR PORT ")}
                type="text"
                errors={fieldErrors}
                value={formData.nvrPort}
                name="nvrPort"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
              </Col>
              <Col lg={6}>
                 <FormInput
                label={t("NVR LOCATION ")}
                type="text"
                errors={fieldErrors}
                value={formData.location}
                name="location"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
              </Col>
              <Col lg={6}>
                <FormInput
                label={t("NVR PASSWORD ")}
                type="text"
                errors={fieldErrors}
                value={formData.nvrPassword}
                name="nvrPassword"
                onChange={inputHandler}
                containerClass={"mb-3"}
              />
              </Col> 
              </Row>
              <div className="d-flex justify-content-center">
                {loading ?
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                  :
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    Submit
                  </Button>
                }
              </div>
            </Card.Body>
          </Card>
        </Col>
      
      </Row>
      {loadingCameraNvr && (<Preloader />)}
      
    </>
  );
};

export default ViewVideo;
